import { Button } from "../button/button";
import { ICON_DATASET } from "./icons";

export class IconPicker extends Button {
	constructor() {
		super();

		this.label = this.getAttribute("label") ?? "";
		this.hiddenName = this.getAttribute("hidden-id");
		this.helperText = this.getAttribute("helper-text") ?? "";
		this.icon = this.getAttribute("icon")?.toLowerCase() ?? "fas fa-icons";

		if (!this.icon.includes(" ")) { this.icon = `fas ${this.icon.trim()}`; }
		if (!this.icon.includes("fa-")) { this.icon = `${this.icon.split(" ").at(0)} fa-${this.icon.split(" ").at(-1)}`; }
		if (!this.#IconExists(this.icon)) { this.icon = "fas fa-icons"; }
		if (this.closest("form") && !this.hiddenName) { this.hiddenName = this.id; }
	}

	#IconExists(icon) {
		return ICON_DATASET.find(x => x.toLowerCase() === icon);
	}

	parsedCallback() {
		const { size, variation, buttonStyle } = this,
			buttonID = crypto.randomUUID().slice(0, 8);

		const container = document.createElementWithContents("chip-dropdownbutton",
			`
				<div class="icon-picker__display"><i></i><i class="fas fa-caret-down"></i></div>

				<chip-dropdown variation="searchable"></chip-dropdown>
			`.trim(), {
			variation, size, buttonStyle
		}), dropdown = container.querySelector("chip-dropdown");

		container.querySelector("i").className = this.icon;

		Object.assign(dropdown, {
			GetSearchedItems: query => this.#GetIcons(query),
			onchange: () => this.icon = dropdown.value,
			hiddenName: this.hiddenName,
			buttonID: buttonID,
			value: this.icon
		});

		if (this.label) {
			this.appendChild(document.createElementWithContents("label", this.label, {
				className: "input-field__label",
				htmlFor: buttonID
			}));
		}

		this.appendChild(container);

		if (this.helperText) {
			this.appendChild(document.createElementWithContents("div", this.helperText, { className: "input-field__helper-text" }));
		}
	}

	#GetIcons(query) {
		return SearchArray(ICON_DATASET, query).map(icon => document.createElementWithContents("chip-dropdownitem",
			`
					<div>
						<i class='${icon}'></i>
					</div>
					<div>
						${toTitleCase(icon.replaceAll('-', ' ').split(" ").slice(2).join(" "))}
					</div>
				`.trim(), { value: icon })).sort(x => x.textContent);
	}

	attributeChanged(name, _, newValue) {
		if (name === "icon") {
			this.querySelector(".icon-picker__display>i:not(:last-child)").className = newValue;
		}
	}
}